import './jobinterview.css'
import React from 'react'
import { ArrowForwardIconWhite } from '../customicons/ArrowForwardIconWhite';
import { ArrowUpward, ArrowDownward} from "@mui/icons-material"
import Stack from '@mui/material/Stack'
import JobInterviewContext from '../../../contexts/JobInterviewContext';
import StatusContext from '../../../contexts/StatusContext'
import MarkdownResponseDisplay from '../markdown/MarkdownResponseDisplay';
import { CustomTooltip } from '../customtooltip/CustomTooltip';

export const DisplayJobInterviewQuestions = ({ text, index}) => {

  let {

    onDisplayQuestion,
    onSendQuestion,
 
  } = React.useContext(JobInterviewContext);

  let {
    changeLanguage,
  
} = React.useContext(StatusContext); 


const handleSendRequest = () => {
   onSendQuestion(index, text.id)
}

  
  const handleDisplayQuestion = () => {
    //shiw/hide question
    onDisplayQuestion(index, text.id)

  }


  return (
    <div key={text.id}>

      {
        (text.subtopic) &&
        <>
          <div className="jobinterviewtopics" >

            <Stack direction="row" spacing={0}>
               <>
               {
                  text.response.length === 0 && 
                  <CustomTooltip title={changeLanguage('comprehensiveresponses', 'sendrequest')}>
                    <span>
                      <ArrowForwardIconWhite onClick={handleSendRequest} /> 
                    </span>
                  </CustomTooltip>
                }
               { text.response.length > 0 && 
                ( text.selected ? 
                  ( <CustomTooltip title={changeLanguage('comprehensiveresponses', 'hideresponse')}>
                     <span>
                      <ArrowUpward className="promptIconColoredOrange" style={{ marginBottom: '5px', cursor: 'pointer' }} onClick={() => handleDisplayQuestion()} />
                     </span>
                    </CustomTooltip> 
                  )
                    :
                  ( 
                    <CustomTooltip title={changeLanguage('comprehensiveresponses', 'showresponse')}>
                     <span>
                       <ArrowDownward className="promptIconColoredOrange" style={{ marginBottom: '5px', cursor: 'pointer' }} onClick={() => handleDisplayQuestion()} />
                     </span>
                     </CustomTooltip> 
                  ) 
                )
                }                     
               </>
              
             <div style={{ color: 'maroon', fontSize:'18px', fontWeight:'500'}}>
                  <MarkdownResponseDisplay text={text.subtopic} />
              </div>
            </Stack>
            
            <div>
             {
               text.selected && 
                <div style={{ color: 'maroon'}}>
                  <MarkdownResponseDisplay text={text.response} />
                </div>
              }
            </div>
          </div>
        </>
      }
    </div>
  )
}